module.exports = __webpack_public_path__ + "media/src/images/icons/flags/india-0adfe75d56e6612ab48c2e6443504c20.svg";